import {Helmet} from '@dr.pogodin/react-helmet';

import i18n from '@dms/i18n';
import {tiresInventoryRoutes, testIds} from '@dms/routes';
import {Main, useGetCurrentBranch, usePermissions} from '@dms/shared';

import {useNavigate} from 'shared/web';

import {TierListOverview} from './(sections)/ListOverview/TierListOverview';
import {TireOrderOverview} from './(sections)/OrderOverview/TireOrderOverview';
import {TireSetsOverview} from './(sections)/SetsOverview/TireSetsOverview';
import {TireSetRequests} from './(sections)/TireSetRequests/TireSetRequests';
import {TireTransportDocumentsOverview} from './(sections)/TireTransportDocumentsOverview/TireTransportDocumentsOverview';

export function TiresInventoryOverview() {
  const navigate = useNavigate();
  const {activeBranchId} = useGetCurrentBranch();
  const [canCreateTireOrder] = usePermissions({
    permissionKeys: ['createTireOrder'],
    scopes: {
      createTireOrder: {
        branchId: activeBranchId,
      },
    },
  });

  return (
    <>
      <Helmet title={i18n.t('page.tiresInventory.labels.tiresInventory')} />
      <Main
        isFullHeight
        tabs={[
          {
            id: 'tireOrders',
            title: i18n.t('page.tiresInventory.labels.tireOrders'),
            content: <TireOrderOverview />,
            href: tiresInventoryRoutes.tireOrders,
            'data-testid': testIds.tiresInventory.tireOrders('tireOrders'),
          },
          {
            id: 'tireSets',
            title: i18n.t('page.tiresInventory.labels.tireSets'),
            content: <TireSetsOverview />,
            href: tiresInventoryRoutes.tireSets,
          },
          {
            id: 'tierList',
            title: i18n.t('page.tiresInventory.labels.tierList'),
            content: <TierListOverview />,
            href: tiresInventoryRoutes.tireList,
            'data-testid': testIds.tiresInventory.tireOrders('tireList'),
          },
          {
            id: 'tierSetRequests',
            title: i18n.t('page.tiresInventory.labels.tiereSetRequests'),
            content: <TireSetRequests />,
            href: tiresInventoryRoutes.tireSetRequests,
            'data-testid': testIds.tiresInventory.tireOrders('tireSetRequests'),
          },
          {
            id: 'tireTransportDocuments',
            title: i18n.t('page.tiresInventory.labels.tireTransportDocuments'),
            content: <TireTransportDocumentsOverview />,
            href: tiresInventoryRoutes.tireTransportDocuments,
            'data-testid': testIds.tiresInventory.tireOrders('tireTransportDocuments'),
          },
        ]}
        actions={[
          {
            type: 'buttonWithTooltip',
            title: i18n.t('page.tiresInventory.labels.newOrder'),
            isDisabled: !canCreateTireOrder,
            onClick: () => navigate(tiresInventoryRoutes.createTireOrder),
            tooltip: {
              label: !canCreateTireOrder ? i18n.t('general.labels.noPermission') : undefined,
            },
          },
        ]}
        data-testid={testIds.tiresInventory.tireOrders('page')}
      />
    </>
  );
}
